var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Move element left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-round-back",
    "data-name": "Icon ionic-md-arrow-round-back",
    d: "M78.691,38.618H30.041L48.91,19.482a8.325,8.325,0,0,0,0-10.893,6.466,6.466,0,0,0-9.821,0L7.671,40.883a7.576,7.576,0,0,0-2.046,5.4v.1a7.576,7.576,0,0,0,2.046,5.4l31.4,32.294a6.466,6.466,0,0,0,9.821,0,8.325,8.325,0,0,0,0-10.893L30.018,54.042h48.65c3.842,0,6.957-3.446,6.957-7.712C85.648,41.992,82.533,38.618,78.691,38.618Z",
    transform: "translate(-5.625 -6.33)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRound);
export default __webpack_public_path__ + "static/media/arrowLeftRound.a60b48cd8f751e3b89a6f7e9290b8cd5.svg";
export { ForwardRef as ReactComponent };